export default {
	methods: {
		getTypeFriendly(value, plural = false) {
			switch (parseInt(value)) {
				case 0:
					return !plural ? 'General Discussion Point' : 'General Discussion Points';
				case 1:
					return !plural ? 'KPI' : "KPI's";
				case 2:
					return !plural ? 'Key Duty' : 'Key Duties';
				case 3:
					return !plural ? '360 Discussion Point' : '360';
				case 4:
					return !plural ? 'Core Value' : 'Core Values';
				case 5:
					return !plural ? 'Person Specification' : 'Person Specification';
			}
			return '';
		},
		getTypeFromText(value) {
			switch (value) {
				case 'General Discussion Point':
				case 'General Discussion Points':
					return 0;
				case 'KPI':
				case "KPI's":
					return 1;
				case 'Key Duty':
				case 'Key Duties':
					return 2;
				case '360 Discussion Point':
				case '360':
					return 3;
				case 'Core Value':
				case 'Core Values':
					return 4;
				case 'Person Specification':
					return 5;
			}
			return 99;
		},
		getTypeChipColor(value) {
			switch (parseInt(value)) {
				case 0:
					return 'indigo';
				case 1:
					return 'orange';
				case 2:
					return 'primary';
				case 3:
					return 'green';
				case 4:
					return 'pink';
				case 5:
					return 'purple';
			}
			return '';
		},
		getPositionTypeFriendly(value) {
			switch (parseInt(value)) {
				case 0:
					return 'Full-time';
				case 1:
					return 'Part-time';
				case 2:
					return 'Casual';
				case 3:
					return 'Fixed Term';
				case 4:
					return 'Shiftworker';
				case 5:
					return 'Daily hire and weekly hire';
				case 6:
					return 'Probation';
				case 7:
					return 'Outworker';
			}
			return '';
		},
		getMeetingLocationType(value) {
			switch (parseInt(value)) {
				case 0:
					return 'Meeting Room';
				case 1:
					return 'Office';
				case 2:
					return 'Other';
			}
		}
	}
};
